import styled from 'styled-components/macro';

import { distances } from '../../../styles/constants';


const Dt = styled.dt`
    padding: 0;
    margin: 0;
    font-weight: 700;
    font-size: 14px;
    line-height: ${distances.normal};
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 4px;

    &:after{
        content: ':';
    }
`;

export default Dt;
